import { useLocation } from "react-router-dom";
import { Switcher, BackButton } from "./../../components/index";
import { useContext, useEffect, useState } from "react";
import {
  ReleaseTrackerDataService,
  softwareNameToId,
} from "../../data/ReleaseTrackerDataService";
import { AuthContext } from "../../auth/AuthHandler";
import { Link } from "react-router-dom";

export default function SearchResults() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const query = params.get("q");
  const authCtx = useContext(AuthContext);

  const switcher = ["Software", "Firmware"];
  const sections = {
    fixed_bugs: "Fixed Bugs",
    implementing_features: "Implementing Features",
    known_bugs: "Known Bugs",
  };
  const sectionOrder = ["implementing_features", "known_bugs", "fixed_bugs"];

  const [state, setState] = useState({
    data: null,
    selected: true,
    selectedItem: switcher[0],
  });

  useEffect(() => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);
    relTrackerService
      .getSearch(query)
      .then((data) => {
        setState((prev) => ({
          ...prev,
          data: data,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [authCtx, query]);

  const setSelectedTab = (value) => {
    setState((prev) => ({
      ...prev,
      selected: true,
      selectedItem: value,
    }));
  };

  const renderResults = () => {
    const selectedKey = state?.selectedItem.toLowerCase();
    const selectedData = state?.data?.[selectedKey];

    const hasResults =
      selectedData &&
      sectionOrder.some(
        (sectionKey) =>
          Array.isArray(selectedData[sectionKey]) &&
          selectedData[sectionKey].length > 0,
      );

    if (!hasResults) {
      return (
        <div className="search-results-no-results">
          {`No results found for "${query}".`}
        </div>
      );
    }

    return sectionOrder
      .filter(
        (sectionKey) =>
          Array.isArray(selectedData[sectionKey]) &&
          selectedData[sectionKey].length > 0,
      )
      .map((sectionKey) => {
        const items = selectedData[sectionKey];

        return (
          <div key={sectionKey} className="search-results-section">
            <h3>{sections[sectionKey] ?? sectionKey}</h3>
            <ul>
              {items.map((item, index) => {
                let url = "#";

                if (selectedKey === "firmware") {
                  url = `/firmware/${item.firmware_device_type}/${item.firmware_family_name}/${item.firmware_name}/${item.version}?tab=${sections[sectionKey]}`;
                } else if (selectedKey === "software") {
                  url = `/software/${softwareNameToId(
                    item.software_name,
                  )}/${item.software_mayor}/${item.version}?tab=${sections[sectionKey]}`;
                }

                const name =
                  selectedKey === "firmware"
                    ? item.firmware_family_name
                    : item.software_name;

                return (
                  <li
                    key={`${item.code}-${item.version}-${index}`}
                    className="search-results-results"
                  >
                    <Link to={url} className="search-results-results-link">
                      <span className="search-results-results-description">
                        {`${item.code} — ${item.name}`}
                      </span>
                      <span className="search-results-results-familyName">
                        {name}
                      </span>
                      <span className="search-results-results-version">
                        {`V${item.version}`}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      });
  };

  return (
    <div className="search-results">
      <BackButton />
      <h2>{`Search results for "${query}"`}</h2>
      <div className="switcher">
        <div className="switcher-scroll">
          {switcher.map((value) => {
            const key = value.toString().replace(/ /g, "").toLowerCase();
            let itemsLength = 0;

            if (state?.data?.[key]) {
              Object.values(state?.data?.[key]).forEach((item) => {
                itemsLength += item.length;
              });
            }

            return (
              <Switcher
                key={key}
                content={value}
                value={value}
                selected={state.selected}
                selectedItem={state.selectedItem}
                itemsLength={itemsLength}
                onClick={() => setSelectedTab(value)}
              />
            );
          })}
        </div>
      </div>
      <div className="search-result-table">{renderResults()}</div>
    </div>
  );
}
